import {
    Box,
    Popover,
    Typography,
} from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

function FlexTimeConfigPopover({ open, anchorEl, onClose, anchorOrigin }) {
    const { t } = useTranslation();

    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={anchorOrigin}
            >
                <Box sx={{ p: '10px', width: '500px', gap: 5 }}>
                    <Trans i18nKey='info' ns='flexTimeConfig'>
                        Dieser Wert ist die Grundlage für die fortlaufende Aktualisierung deines Arbeitszeitkontos.
                        <br /><br />Beim Einrichten deines Arbeitszeitkontos hast du einen Startwert angegeben. Da wir deine erfassten Arbeitszeiten nur zwei Jahre verwahren, aktualisieren wir diesen Referenzwert jährlich.
                        <br /><br />Vorsicht! Bearbeite ihn nur, wenn es zwingend erforderlich ist.
                    </Trans>
                </Box>
            </Popover>
        </>
    );
};

export default FlexTimeConfigPopover
